<template>
  <div class="bg-secondary-3 px-4 pb-4">
    <div class="row">
      <div class="col-12 mb-2">
        <icon-view
          :has-border="false"
          icon="fas fa-sliders-v text-orange"
          icon-size="17px"
          title="Ajustar Referido"
          variant="custom-icon-view"
          icon-background="white"
        />
      </div>
    </div>
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row mt-2">
        <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
          <div class="color-black font-14 my-1 mb-2">Razón:</div>
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              custom-error-msg="La razón es requerida"
              :error="errors[0]"
              :clearable="false"
              :options="ajustmentReasons"
              v-model="model.reasonId"
            />
          </validation-provider>
        </div>

        <div class="col-12 mt-2">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="color-black font-14 mt-1 mb-2">
              Comentario de Ajuste:
            </div>
            <custom-text-area
              id="txtComment"
              v-model="model.comment"
              :count-classes="['d-block', 'small-counter', 'text-right']"
              custom-error-msg="El comentario es requerido"
              :error="errors[0]"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              show-char-count
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('cancel')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handleAjustReferral"
      />
    </div>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomFileInput from 'CustomFileInput';
import CustomTextArea from '@quisit/custom-text-area';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import referralAndEquipmentsService from '@/services/api/referralsandequipments.api';

export default {
  name: 'AjustReferral',
  components: {
    CustomInput,
    CustomFileInput,
    CustomTextArea,
    ActionButton,
    IconView,
    CustomDropDown,
  },
  data: () => ({
    ajustmentReasons: [],
  }),
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async handleAjustReferral() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }
      this.$emit('save');
    },
  },
  async mounted() {
    var {
      data,
    } = await referralAndEquipmentsService
      .getAjustmentReasons()
      .catch((error) => {
        if (err && err.response && err.response.data) {
          this.ShowToast('Error', err.response.data.message, 'error');
        } else {
          this.ShowToast('Error', err.message, 'error');
        }
      });
    this.ajustmentReasons = data;
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dot {
  padding: 19px !important;
}
</style>
